angular.module('clientDashboardApp').controller("UploadToolCtrl", (
  $state, $scope, $interval, $http,
  accountsService, Socket, Upload
) => {

  $scope.auditOnly = false;
  $scope.update = false;

  $scope.statusHistory = [];
  let status;
  $scope.selectedAccount = undefined
  $scope.onAccountSelected = (account) => {
    $scope.selectedAccount = account
  }

  const newImportState = () => ({
    saveStarted: false,
    started: false,
    complete: false,
    failed: false,
    hadErrors: false,
    errors: [],
  })
  $scope.resetUploadStatus = () => {
    if (status) {
      $scope.statusHistory.push(status)
    }
    $scope.status = status = window.uploadStatus = {
      uploadStarted: false,
      uploadComplete: false,
      importState: newImportState(),
      locationImport: undefined,
      log: [],
      overall: {
        title: 'Overall',
        progress: 0,
        total: 0,
      },
      subtask: {
        title: '',
        progress: 0,
        total: 0
      }
    }
  }
  $scope.resetUploadStatus()

  $scope.getStatusDescription = () => {
    if (!status.importState.complete) {
      return {
        icon: 'fa-spin fa-spinner',
        text: !status.uploadComplete ?
          'Uploading ...' :
          status.importState.started ?
            (status.importState.saveStarted ? 'Importing ...' : 'Validating ... ') :
            'Uploaded',
        instructions: status.uploadComplete && !status.importState.started ? 'Click Validate or Save to continue' : undefined,
        color: 'text-primary'
      }
    } else if (status.importState.failed) {
      return {
        icon: 'fa-times', text: 'Failed', color: 'text-danger',
        instructions: 'You must fix or remove the failed rows to finish the import'
      }
    } else if (status.importState.hadErrors) {
      return {
        icon: 'fa-warning', text: 'Complete with errors', color: 'text-warning',
        instructions: 'You can download the failed rows, fix them, and try again'
      }
    } else {
      return {
        icon: 'fa-check',
        text: status.importState.saveStarted ? 'Import Success' : 'Validation Success',
        color: 'text-success',
        instructions: status.importState.saveStarted ? undefined : 'Click Save to continue'
      }
    }
  }

  $scope.cannotStartImport = () => {
    return status.importState.failed ||
      (status.importState.started && !status.importState.complete) ||
      status.importState.saveStarted
  }


  $scope.downloadRows = (subsetType) => {
    $http({
      url: '/admin/uploadTool/generateSubsetLink',
      method: 'POST',
      params: {
        importId: status.locationImport.locationImportId,
        subsetType
      },
      data: status.importState.errors
        .filter(x => x.row !== undefined && x.sheet)
        .map(({ row, message, sheet}) => ({row, message, sheet})) // remove extra fields
    }).then(x => {
      window.location = x.data
    })
  }



  // This initializes the socket connection, so it's ready for when we start the upload
  Socket.on("keepalive", (msg) => "nop")
  $scope.$on("$destroy", event => { Socket.off("keepalive") })


  $scope.upload = function (files) {
    const file = files && files[0]

    if (file) {
      status.uploadStarted = true;
      appendLog("Uploading file ...")

      const accountId = $scope.selectedAccount ? {
        accountId: $scope.selectedAccount.value
      } : {};

      Upload.upload({
        url: '/admin/uploadTool/upload',
        fields: {
          update: $scope.update,
          ...accountId
        },
        file: file
      }).progress(e => {
        // fake the file upload as 1/12 of the overall progress
        status.overall.total = 12;
        status.overall.progress = e.loaded / e.total;
      }).success((data) => {
        appendLog("Upload Succeeded. Awaiting next command")
        status.uploadComplete = true;
        status.locationImport = data
      }).error(data => {
        status.failed = true;
        appendLog("Upload Failed")
        status.errors.push({
          message: "Problem uploading file: " + data
        })
      })

    }
  }

  $scope.startImport = (testRun) => {
    appendLog('------------------------------------------')

    status.importState = {
      ...newImportState(),
      started: true,
      saveStarted: !testRun,
    };

    appendLog(testRun ? 'Running Validation' : 'Running Import')
    appendLog('------------------------------------------')
    appendLog('')
    Socket.on("file-processing:" + status.locationImport.locationImportId, dispatchMessage).then(() => {
      $http.post(
        "/admin/uploadTool/import/" + status.locationImport.locationImportId, {
          testRun: testRun, auditOnly: $scope.auditOnly
        }
      ).then((res) => {

      });
    });
  }

  // see UploadToolMessagingFacade.scala
  const handlers = {
    "Log": data => appendLog(data),
    // progress can be buggy if messages come in too fast (out of order). Especially on SubtaskProgress
    "OverallProgress": data => {
      status.overall.status = data.status;
      status.overall.total = data.total;
      status.overall.progress = (status.overall.progress || 0) + data.incr; // messages can be out of order.

    },
    "SubtaskProgress": data => {
      Object.assign(status.subtask, {
        title: data.title,
        progress: (data.title === status.subtask.title) ?
          ((status.subtask.progress || 0) + data.incr) :
          (0 + data.incr),
        total: data.total
      })
    },
    "Errors": data => {
      status.importState.errors.push(data)
    },
    "Complete": data => {

      status.overall.status = '';
      Object.assign(status.importState, {
        complete: true,
        failed: data.failed,
        hadErrors: data.hadErrors
      });
      setTimeout(() => Socket.off("file-processing:" + status.locationImport.locationImportId), 1000);
    },
  }

  $scope.errorDescription = (error) => {
    const prefix = error.sheet ?
      error.sheet + (error.row !== undefined ? ' (' + (error.row + 2) + ') ' : '') + ': ' :
      '';
    return prefix + error.message
  }

  function appendLog(message) {
    status.log = status.log.concat({ timestamp: moment().utc().format(), message })
  }
  function dispatchMessage(data) {
    const handler = handlers[data.type]
    if (!handler) {
      console.warn('received unknown message type!', data)
    } else {
      handler(data.data)
    }
  }

});
